#version 300 es
/*
* Preprocessed + Optimized from './film-grain.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform vec4 uOutputFrame;
uniform float u_intensity;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;

void main()
{
    vec4 _1054 = texture(uTexture, vTextureCoord);
    vec3 _1063 = _1054.xyz;
    vec2 _1090 = uOutputFrame.xy * vec2(0.5);
    vec2 _1140 = vTextureCoord * _1090;
    vec3 _1148 = vec3(_1140 * vec2(0.4000000059604644775390625), 0.0);
    vec3 _1210 = floor(_1148 + vec3(dot(_1148, vec3(0.3333333432674407958984375))));
    vec3 _1217 = (_1148 - _1210) + vec3(dot(_1210, vec3(0.16666667163372039794921875)));
    vec3 _1221 = step(_1217.yzx, _1217);
    vec3 _1227 = (vec3(1.0) - _1221).zxy;
    vec3 _1228 = min(_1221, _1227);
    vec3 _1232 = max(_1221, _1227);
    vec3 _1236 = (_1217 - _1228) + vec3(0.16666667163372039794921875);
    vec3 _1240 = (_1217 - _1232) + vec3(0.3333333432674407958984375);
    vec3 _1242 = _1217 - vec3(0.5);
    vec3 _1472 = _1210 - (floor(_1210 * 0.00346020772121846675872802734375) * 289.0);
    vec4 _1253 = vec4(_1472.z) + vec4(0.0, _1228.z, _1232.z, 1.0);
    vec4 _1481 = ((_1253 * 34.0) + vec4(1.0)) * _1253;
    vec4 _1264 = ((_1481 - (floor(_1481 * 0.00346020772121846675872802734375) * 289.0)) + vec4(_1472.y)) + vec4(0.0, _1228.y, _1232.y, 1.0);
    vec4 _1499 = ((_1264 * 34.0) + vec4(1.0)) * _1264;
    vec4 _1275 = ((_1499 - (floor(_1499 * 0.00346020772121846675872802734375) * 289.0)) + vec4(_1472.x)) + vec4(0.0, _1228.x, _1232.x, 1.0);
    vec4 _1517 = ((_1275 * 34.0) + vec4(1.0)) * _1275;
    vec4 _1526 = _1517 - (floor(_1517 * 0.00346020772121846675872802734375) * 289.0);
    vec4 _1290 = _1526 - (floor((_1526 * 0.14285714924335479736328125) * 0.14285714924335479736328125) * 49.0);
    vec4 _1295 = floor(_1290 * 0.14285714924335479736328125);
    vec4 _1307 = (_1295 * 0.2857142984867095947265625) + vec4(-0.928571403026580810546875);
    vec4 _1314 = (floor(_1290 - (_1295 * 7.0)) * 0.2857142984867095947265625) + vec4(-0.928571403026580810546875);
    vec4 _1321 = (vec4(1.0) - abs(_1307)) - abs(_1314);
    vec4 _1330 = vec4(_1307.xy, _1314.xy);
    vec4 _1339 = vec4(_1307.zw, _1314.zw);
    vec4 _1352 = -step(_1321, vec4(0.0));
    vec4 _1360 = _1330.xzyw + (((floor(_1330) * 2.0) + vec4(1.0)).xzyw * _1352.xxyy);
    vec4 _1368 = _1339.xzyw + (((floor(_1339) * 2.0) + vec4(1.0)).xzyw * _1352.zzww);
    vec3 _1375 = vec3(_1360.xy, _1321.x);
    vec3 _1382 = vec3(_1360.zw, _1321.y);
    vec3 _1389 = vec3(_1368.xy, _1321.z);
    vec3 _1396 = vec3(_1368.zw, _1321.w);
    vec4 _1532 = vec4(1.792842864990234375) - (vec4(dot(_1375, _1375), dot(_1382, _1382), dot(_1389, _1389), dot(_1396, _1396)) * 0.8537347316741943359375);
    vec4 _1443 = max(vec4(0.60000002384185791015625) - vec4(dot(_1217, _1217), dot(_1236, _1236), dot(_1240, _1240), dot(_1242, _1242)), vec4(0.0));
    vec4 _1446 = _1443 * _1443;
    vec3 _1154 = vec3(_1140, 42.0 * dot(_1446 * _1446, vec4(dot(_1375 * _1532.x, _1217), dot(_1382 * _1532.y, _1236), dot(_1389 * _1532.z, _1240), dot(_1396 * _1532.w, _1242))));
    vec3 _1162 = vec3((vec2(1.0) / vTextureCoord) * _1090, 1.0);
    vec3 _1588 = mod(floor(_1154), _1162);
    vec3 _1592 = mod(_1588 + vec3(1.0), _1162);
    vec3 _1924 = _1588 - (floor(_1588 * 0.00346020772121846675872802734375) * 289.0);
    vec3 _1932 = _1592 - (floor(_1592 * 0.00346020772121846675872802734375) * 289.0);
    vec3 _1598 = fract(_1154);
    vec3 _1600 = _1598 - vec3(1.0);
    float _1602 = _1924.x;
    float _1604 = _1932.x;
    vec4 _1609 = vec4(_1602, _1604, _1602, _1604);
    vec4 _1941 = ((_1609 * 34.0) + vec4(1.0)) * _1609;
    vec4 _1626 = (_1941 - (floor(_1941 * 0.00346020772121846675872802734375) * 289.0)) + vec4(_1924.yy, _1932.yy);
    vec4 _1959 = ((_1626 * 34.0) + vec4(1.0)) * _1626;
    vec4 _1968 = _1959 - (floor(_1959 * 0.00346020772121846675872802734375) * 289.0);
    vec4 _1630 = _1968 + _1924.zzzz;
    vec4 _1977 = ((_1630 * 34.0) + vec4(1.0)) * _1630;
    vec4 _1634 = _1968 + _1932.zzzz;
    vec4 _1995 = ((_1634 * 34.0) + vec4(1.0)) * _1634;
    vec4 _1637 = (_1977 - (floor(_1977 * 0.00346020772121846675872802734375) * 289.0)) * 0.14285714924335479736328125;
    vec4 _1643 = fract(floor(_1637) * 0.14285714924335479736328125) - vec4(0.5);
    vec4 _1645 = fract(_1637);
    vec4 _1651 = (vec4(0.5) - abs(_1645)) - abs(_1643);
    vec4 _1653 = step(_1651, vec4(0.0));
    vec4 _1662 = _1645 - (_1653 * (step(vec4(0.0), _1645) - vec4(0.5)));
    vec4 _1671 = _1643 - (_1653 * (step(vec4(0.0), _1643) - vec4(0.5)));
    vec4 _1673 = (_1995 - (floor(_1995 * 0.00346020772121846675872802734375) * 289.0)) * 0.14285714924335479736328125;
    vec4 _1679 = fract(floor(_1673) * 0.14285714924335479736328125) - vec4(0.5);
    vec4 _1681 = fract(_1673);
    vec4 _1687 = (vec4(0.5) - abs(_1681)) - abs(_1679);
    vec4 _1689 = step(_1687, vec4(0.0));
    vec4 _1698 = _1681 - (_1689 * (step(vec4(0.0), _1681) - vec4(0.5)));
    vec4 _1707 = _1679 - (_1689 * (step(vec4(0.0), _1679) - vec4(0.5)));
    vec3 _1714 = vec3(_1662.x, _1671.x, _1651.x);
    vec3 _1721 = vec3(_1662.y, _1671.y, _1651.y);
    vec3 _1728 = vec3(_1662.z, _1671.z, _1651.z);
    vec3 _1735 = vec3(_1662.w, _1671.w, _1651.w);
    vec3 _1742 = vec3(_1698.x, _1707.x, _1687.x);
    vec3 _1749 = vec3(_1698.y, _1707.y, _1687.y);
    vec3 _1756 = vec3(_1698.z, _1707.z, _1687.z);
    vec3 _1763 = vec3(_1698.w, _1707.w, _1687.w);
    vec4 _2010 = vec4(1.792842864990234375) - (vec4(dot(_1714, _1714), dot(_1728, _1728), dot(_1721, _1721), dot(_1735, _1735)) * 0.8537347316741943359375);
    vec4 _2016 = vec4(1.792842864990234375) - (vec4(dot(_1742, _1742), dot(_1756, _1756), dot(_1749, _1749), dot(_1763, _1763)) * 0.8537347316741943359375);
    float _1829 = _1600.x;
    float _1832 = _1598.y;
    float _1833 = _1598.z;
    float _1838 = _1598.x;
    float _1840 = _1600.y;
    float _1858 = _1600.z;
    vec3 _2032 = ((_1598 * _1598) * _1598) * ((_1598 * ((_1598 * 6.0) - vec3(15.0))) + vec3(10.0));
    vec4 _1899 = mix(vec4(dot(_1714 * _2010.x, _1598), dot(_1721 * _2010.z, vec3(_1829, _1832, _1833)), dot(_1728 * _2010.y, vec3(_1838, _1840, _1833)), dot(_1735 * _2010.w, vec3(_1829, _1840, _1833))), vec4(dot(_1742 * _2016.x, vec3(_1838, _1832, _1858)), dot(_1749 * _2016.z, vec3(_1829, _1832, _1858)), dot(_1756 * _2016.y, vec3(_1838, _1840, _1858)), dot(_1763 * _2016.w, _1600)), vec4(_2032.z));
    vec2 _1907 = mix(_1899.xy, _1899.zw, vec2(_2032.y));
    float _1165 = mix(_1907.x, _1907.y, _2032.x) * 1.10000002384185791015625;
    float _1166 = _1165 + 0.5;
    float _2042 = _1054.x;
    bool _2061 = _1166 < 0.5;
    float _2240;
    if (_2061)
    {
        _2240 = ((2.0 * _2042) * _1166) + ((_2042 * _2042) * (1.0 - (2.0 * _1166)));
    }
    else
    {
        _2240 = (sqrt(_2042) * ((2.0 * _1166) - 1.0)) + ((2.0 * _2042) * (0.5 - _1165));
    }
    float _2047 = _1054.y;
    float _2241;
    if (_2061)
    {
        _2241 = ((2.0 * _2047) * _1166) + ((_2047 * _2047) * (1.0 - (2.0 * _1166)));
    }
    else
    {
        _2241 = (sqrt(_2047) * ((2.0 * _1166) - 1.0)) + ((2.0 * _2047) * (0.5 - _1165));
    }
    float _2052 = _1054.z;
    float _2242;
    if (_2061)
    {
        _2242 = ((2.0 * _2052) * _1166) + ((_2052 * _2052) * (1.0 - (2.0 * _1166)));
    }
    else
    {
        _2242 = (sqrt(_2052) * ((2.0 * _1166) - 1.0)) + ((2.0 * _2052) * (0.5 - _1165));
    }
    fragColor = vec4(mix(_1063, mix(vec3(_2240, _2241, _2242), _1063, vec3(pow(smoothstep(0.0500000007450580596923828125, 0.5, dot(_1063, vec3(0.2989999949932098388671875, 0.58700001239776611328125, 0.114000000059604644775390625))), 2.0))), vec3(u_intensity)), _1054.w);
}
